/**
 * Horizontal scroll hint for K tables on narrow viewports.
 */
export function initTableScrollHints() {
    const roots = document.querySelectorAll('[data-k-table-scroll]');
    if (!roots.length) {
        return;
    }

    const update = (wrap) => {
        const viewport = wrap.querySelector('.k-table-scroll__viewport');
        const hint = wrap.querySelector('.k-table-scroll__hint');
        if (!viewport) {
            return;
        }

        const canScroll = viewport.scrollWidth > viewport.clientWidth + 2;
        wrap.classList.toggle('is-scrollable', canScroll);

        if (hint) {
            if (canScroll) {
                hint.hidden = false;
            } else {
                hint.hidden = true;
            }
        }

        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        const atStart = viewport.scrollLeft <= 2;
        const atEnd = viewport.scrollLeft >= maxScroll - 2;

        wrap.classList.toggle('is-at-start', atStart);
        wrap.classList.toggle('is-at-end', atEnd);

        if (viewport.scrollLeft > 12) {
            wrap.classList.add('is-scrolled');
        }
    };

    roots.forEach((wrap) => {
        const viewport = wrap.querySelector('.k-table-scroll__viewport');
        if (!viewport) {
            return;
        }

        const onUpdate = () => update(wrap);
        viewport.addEventListener('scroll', onUpdate, { passive: true });
        window.addEventListener('resize', onUpdate);

        if (typeof ResizeObserver !== 'undefined') {
            const ro = new ResizeObserver(onUpdate);
            ro.observe(viewport);
            const table = viewport.querySelector('.k-qualifications');
            if (table) {
                ro.observe(table);
            }
        }

        onUpdate();
    });
}
